import React from "react";

function Icon({ className }: { className: string }) {
  return (
    <svg viewBox="0 0 50.401 61.201" className={className}>
      <path
        d="M21.9,51.3H43.5V29.7H57.9L32.7,4.5,7.5,29.7H21.9ZM7.5,58.5H57.9v7.2H7.5Z"
        transform="translate(-7.5 -4.5)"
      />
    </svg>
  );
}

export { Icon };
